module.exports = __webpack_public_path__ + "static/media/Slide12.9cb7df04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/Slide12.png
// module id = 1634
// module chunks = 0